import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { checkLoginStatus, getCsrfToken, login, signup } from "../API/res";
import { AuthContext } from "../components/AuthContext";



const AuthPage = () => {
  const navigate = useNavigate();
  // const { setUser } = useContext(AuthContext);
  const [isLogin, setIsLogin] = useState(true);
  const { setIsAuthenticated , setUser } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    username: "",
    first_name: "",
    last_name: "",
    phone: "",
    usertype: "student",
    email: "",
    password: "",
    confirm_password: "",
  });

  const toggleMode = () => {
    setIsLogin(!isLogin);
    setFormData({
      username: "",
      first_name: "",
      last_name: "",
      phone: "",
      usertype: "student",
      email: "",
      password: "",
      confirm_password: "",
    });
  };

 


  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };


  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    if (isLogin) {
      // Call the login API
      const loginResponse = await login({
        username: formData.username,
        password: formData.password,
      });
  console.log("Login successful:", loginResponse);

  // Log the full response for debugging
  console.log("Full login response:", loginResponse);

  // Adjust this logic based on the actual structure of loginResponse
  // For example, if loginResponse.data contains user info and loginResponse.headers['set-cookie'] contains the cookie:
  const responseData = loginResponse?.responseData || loginResponse?.data || loginResponse?.user || loginResponse;
  const cookieHeader = loginResponse?.cookieHeader || loginResponse?.headers?.['set-cookie'];

  if (responseData && (cookieHeader || true)) { // Remove '|| true' if cookieHeader is required
    if (cookieHeader) {
      console.log('Main.js Cookie:', cookieHeader);
      await checkLoginStatus();
      await getCsrfToken();
    }
    // setUser({ username: responseData.username || responseData.user?.username, email: responseData.email || responseData.user?.email });

    setUser({
  username:
    responseData.username ||
    responseData.user?.username ||
    formData.username,
  email: responseData.email || responseData.user?.email || "",
});
setIsAuthenticated(true);

sessionStorage.setItem(
  "user",
  JSON.stringify({
    username:
      responseData.username ||
      responseData.user?.username ||
      formData.username,
    email: responseData.email || responseData.user?.email || "",
  })
);

localStorage.setItem(
  "user",
  JSON.stringify({
    username:
      responseData.username ||
      responseData.user?.username ||
      formData.username,
    email: responseData.email || responseData.user?.email || "",
  })
);
localStorage.setItem("isAuthenticated", "true");
    navigate("/");
  } else {
    // Log the full response for debugging
    console.error("Unexpected login response structure:", loginResponse);
    alert("Login failed: Unexpected response from server.");
  }
    } else {
      if (formData.password !== formData.confirm_password) {
        alert("Passwords do not match!");
        return;
      }
    

      // Call the register API
      const registerResponse = await signup(formData);
      console.log("Registration successful:", registerResponse);

      // Switch to login mode after signup
      setIsLogin(true);
      setFormData({
        username: "",
        first_name: "",
        last_name: "",
        phone: "",
        usertype: "student",
        email: "",
        password: "",
        confirm_password: "",
      });
    }
  }
   catch (error) {
    console.error("Error:", error.message);
    alert(error.message || "Something went wrong");
  }
};


  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-md bg-white p-8 rounded-xl shadow-md">
        <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">
          {isLogin ? "Login" : "Register"}
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          {!isLogin && (
            <>
              <input
                type="text"
                name="first_name"
                placeholder="First Name"
                value={formData.first_name}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="text"
                name="last_name"
                placeholder="Last Name"
                value={formData.last_name}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />

               <input
                type="text"
                name="phone"
                placeholder="Phone"
                value={formData.phone}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />

               <select
                name="usertype"
                value={formData.usertype}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="student">Student</option>
                <option value="educator">Educator</option>
                <option value="interviewer">Interviewer</option>
                <option value="corporate">Corporate</option>
              </select>
{/* 
              <input
                type="password"
                name="confirm_password"
                placeholder="Confirm Password"
                value={formData.confirm_password}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              /> */}
             
             
            </>
          )}

          <input
            type="text"
            name="username"
            placeholder="Username"
            value={formData.username}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
          {!isLogin && (
            <input
              type="password"
              name="confirm_password"
              placeholder="Confirm Password"
              value={formData.confirm_password}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          )}


          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
          >
            {isLogin ? "Login" : "Register"}
          </button>
        </form>

        <p className="mt-4 text-center text-sm text-gray-600">
          {isLogin ? "Don't have an account?" : "Already have an account?"}{" "}
          <button
            onClick={toggleMode}
            className="text-blue-600 hover:underline font-medium"
          >
            {isLogin ? "Register here" : "Login here"}
          </button>
        </p>
      </div>
    </div>
  );
};



export default AuthPage;

